module.exports = __webpack_public_path__ + "img/bmw-1024x476.6747a343.png";